import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type LegalKey = 'terms' | 'privacy' | null;
const LEGAL_CONTENT: Record<Exclude<LegalKey, null>, {
  title: string;
  body: React.ReactNode;
}> = {
  terms: {
    title: 'Términos y Condiciones',
    body: <div className="space-y-5 text-brand-navy/80 leading-relaxed" data-id="element-26">
        <p data-id="element-27">
          Bienvenida a El Método de los 90 Segundos. Al adquirir y utilizar este
          producto digital aceptas los siguientes términos y condiciones.
        </p>

        <div data-id="element-28">
          <h4 className="font-bold text-brand-navy mb-2" data-id="element-29">
            1. Sobre el producto
          </h4>
          <p data-id="element-30">
            El Método de los 90 Segundos es un producto digital educativo en
            formato de guía descargable. Su contenido tiene fines informativos y
            de acompañamiento parental, y no sustituye la atención profesional
            de salud mental, médica o psicológica.
          </p>
        </div>

        <div data-id="element-31">
          <h4 className="font-bold text-brand-navy mb-2" data-id="element-32">2. Licencia de uso</h4>
          <p data-id="element-33">
            Tu compra te otorga una licencia personal, intransferible y no
            exclusiva para uso individual y familiar. No está permitido
            redistribuir, revender, copiar parcial o totalmente, ni compartir el
            contenido sin autorización por escrito.
          </p>
        </div>

        <div data-id="element-34">
          <h4 className="font-bold text-brand-navy mb-2" data-id="element-35">3. Pagos</h4>
          <p data-id="element-36">
            Todos los pagos se procesan a través de plataformas seguras de
            terceros. El precio mostrado está expresado en dólares
            estadounidenses (USD) e incluye todos los impuestos aplicables, a
            menos que se indique lo contrario.
          </p>
        </div>

        <div data-id="element-37">
          <h4 className="font-bold text-brand-navy mb-2" data-id="element-38">
            4. Política de reembolso
          </h4>
          <p data-id="element-39">
            Por tratarse de un producto digital de descarga inmediata, una vez
            entregado el acceso no se realizan reembolsos, salvo en casos de
            error técnico verificable que impida la entrega del producto.
          </p>
        </div>

        <div data-id="element-40">
          <h4 className="font-bold text-brand-navy mb-2" data-id="element-41">5. Resultados</h4>
          <p data-id="element-42">
            Los resultados pueden variar según cada familia, niño y contexto. No
            garantizamos resultados específicos. El compromiso y la aplicación
            del método por parte del usuario son determinantes.
          </p>
        </div>

        <div data-id="element-43">
          <h4 className="font-bold text-brand-navy mb-2" data-id="element-44">
            6. Limitación de responsabilidad
          </h4>
          <p data-id="element-45">
            No nos hacemos responsables por decisiones tomadas con base en el
            contenido del producto. Para situaciones clínicas, conductuales o
            emocionales graves, consulta siempre a un profesional cualificado.
          </p>
        </div>

        <div data-id="element-46">
          <h4 className="font-bold text-brand-navy mb-2" data-id="element-47">7. Modificaciones</h4>
          <p data-id="element-48">
            Nos reservamos el derecho de actualizar estos términos en cualquier
            momento. Las modificaciones entrarán en vigor desde su publicación
            en este sitio.
          </p>
        </div>
      </div>
  },
  privacy: {
    title: 'Política de Privacidad',
    body: <div className="space-y-5 text-brand-navy/80 leading-relaxed" data-id="element-49">
        <p data-id="element-50">
          Tu privacidad es importante para nosotros. Esta política describe qué
          datos recogemos, cómo los usamos y cuáles son tus derechos al
          interactuar con El Método de los 90 Segundos.
        </p>

        <div data-id="element-51">
          <h4 className="font-bold text-brand-navy mb-2" data-id="element-52">
            1. Datos que recogemos
          </h4>
          <p data-id="element-53">
            Recopilamos únicamente la información necesaria para procesar tu
            compra y entregarte el producto: nombre, correo electrónico y datos
            de pago (gestionados por proveedores externos seguros).
          </p>
        </div>

        <div data-id="element-54">
          <h4 className="font-bold text-brand-navy mb-2" data-id="element-55">
            2. Uso de la información
          </h4>
          <p data-id="element-56">
            Usamos tus datos para entregar el producto, enviarte información
            relacionada con tu compra y, si lo autorizas, comunicaciones
            educativas u ofertas relevantes. Nunca vendemos tus datos.
          </p>
        </div>

        <div data-id="element-57">
          <h4 className="font-bold text-brand-navy mb-2" data-id="element-58">3. Pagos seguros</h4>
          <p data-id="element-59">
            Los pagos son procesados por plataformas externas con cifrado
            estándar de la industria. No almacenamos información completa de
            tarjetas de crédito en nuestros servidores.
          </p>
        </div>

        <div data-id="element-60">
          <h4 className="font-bold text-brand-navy mb-2" data-id="element-61">4. Cookies</h4>
          <p data-id="element-62">
            Utilizamos cookies para mejorar tu experiencia de navegación,
            analizar el tráfico y, en su caso, optimizar campañas publicitarias.
            Puedes desactivarlas desde la configuración de tu navegador.
          </p>
        </div>

        <div data-id="element-63">
          <h4 className="font-bold text-brand-navy mb-2" data-id="element-64">5. Terceros</h4>
          <p data-id="element-65">
            Compartimos datos únicamente con proveedores estrictamente
            necesarios (procesadores de pago, plataforma de envío de correos y
            entrega digital), bajo acuerdos de confidencialidad.
          </p>
        </div>

        <div data-id="element-66">
          <h4 className="font-bold text-brand-navy mb-2" data-id="element-67">6. Tus derechos</h4>
          <p data-id="element-68">
            Tienes derecho a acceder, rectificar o eliminar tus datos
            personales. Para ejercerlos puedes contactarnos a través de los
            canales indicados en el sitio.
          </p>
        </div>

        <div data-id="element-69">
          <h4 className="font-bold text-brand-navy mb-2" data-id="element-70">
            7. Cambios en esta política
          </h4>
          <p data-id="element-71">
            Podemos actualizar esta política de privacidad periódicamente.
            Cualquier cambio será publicado en esta misma página.
          </p>
        </div>
      </div>
  }
};
export function Footer() {
  const [open, setOpen] = useState<LegalKey>(null);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(null);
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);
  return <>
      <footer className="bg-brand-navy text-white/60 py-12 px-6 text-center text-sm" data-id="element-72">
        <div className="max-w-3xl mx-auto space-y-6" data-id="element-73">
          <p className="font-serif text-xl text-white/90 italic" data-id="element-74">
            El Método de los 90 Segundos
          </p>
          <p data-id="element-75">
            Este contenido es educativo y no sustituye atención profesional de
            salud mental, médica o psicológica. Si tu hijo o tú necesitan ayuda
            profesional, por favor acude a un especialista.
          </p>
          <div className="flex justify-center gap-6 pt-6 border-t border-white/10" data-id="element-76">
            <button type="button" onClick={() => setOpen('terms')} className="hover:text-white transition-colors" data-id="element-77">
              Términos y Condiciones
            </button>
            <button type="button" onClick={() => setOpen('privacy')} className="hover:text-white transition-colors" data-id="element-78">
              Política de Privacidad
            </button>
          </div>
          <p className="pt-4" data-id="element-79">
            &copy; {new Date().getFullYear()} Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-80">
        {open && <motion.div key="legal-modal" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-6 bg-black/60 backdrop-blur-sm" onClick={() => setOpen(null)} role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-81">
            <motion.div initial={{
          y: 40,
          opacity: 0,
          scale: 0.98
        }} animate={{
          y: 0,
          opacity: 1,
          scale: 1
        }} exit={{
          y: 40,
          opacity: 0,
          scale: 0.98
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-brand-cream w-full max-w-2xl max-h-[90vh] sm:max-h-[85vh] rounded-t-3xl sm:rounded-3xl shadow-2xl flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-82">
              <div className="flex items-center justify-between px-6 sm:px-8 py-5 border-b border-brand-sage/20 bg-white/60" data-id="element-83">
                <h3 id="legal-modal-title" className="font-serif text-2xl font-bold text-brand-navy" data-id="element-84">
                  {LEGAL_CONTENT[open].title}
                </h3>
                <button type="button" onClick={() => setOpen(null)} aria-label="Cerrar" className="p-2 rounded-full hover:bg-brand-navy/10 text-brand-navy transition-colors" data-id="element-85">
                  <X size={20} data-id="element-86" />
                </button>
              </div>
              <div className="overflow-y-auto px-6 sm:px-8 py-6 text-left" data-id="element-87">
                {LEGAL_CONTENT[open].body}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}